import React from "react";
import { connect } from "react-redux";

import { isIOS } from "react-device-detect";

import DateRangePicker from "react-bootstrap-daterangepicker";

import { moment, wdType, convertToHourText, formatTime } from "../../common/common";
import { getEndDatewd } from "../../common/wdfunction";

import {
	IcLocationSearch,
	IcBack,
	IcCalendarSearch,
	IcStartLocWD,
	IcEndLocWD,
	IcCloseOrange,
	IcPlusCGreen,
	IcCompass,
	IcTime,
	IcQuestion,
} from "../../common/svg";

import DateBox from "../../common/datebox";
import DateBoxWD from "../../common/dateboxwd";

import HereAutoComplete from "../../common/hereautocomplete";
import SearchSuggest from "../../common/searchsuggest";

class SearchBox extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isCalendar: false,
		};
	}

	onTripModeChange = (boolean) => {
		this.props.onTripModeChange(boolean);
	};

	onOneWayChange = () => {
		this.props.onOneWayChange();
	};

	onAddStopPoint = () => {
		this.props.onAddStopPoint();
	};

	onRemoveStopPoint = (i) => {
		this.props.onRemoveStopPoint(i);
	};

	showWdTypeInfoBox = (wdType) => {
		this.props.showWdTypeInfoBox(wdType);
	};

	onStartTimeChange = (time) => {
		this.props.onStartTimeChange(time);
	};

	onEndTimeChange = (time) => {
		this.props.onEndTimeChange(time);
	};

	onStartDateChange = (event, picker) => {
		this.props.onStartDateChange(event, picker);
	};

	onEndDateChange = (event, picker) => {
		this.props.onEndDateChange(event, picker);
	};

	onSelectHourChange = (e) => {
		this.props.onSelectHourChange(e);
	};

	toggleDurationTimeBox = (isSelectHour) => {
		this.props.toggleDurationTimeBox(isSelectHour);
	};

	hide = () => {
		this.props.hide();
	};

	onSelectAddress = (address, i) => {
		this.props.onSelectAddress(address, i);
	};

	onDateRangeChange = (picker) => {
		this.props.onDateRangeChange(picker);
	};

	openCalendar = () => {
		this.setState({
			isCalendar: true,
		});
	};

	hideCalendar = () => {
		this.setState({
			isCalendar: false,
		});
	};

	openWDCalendar = () => {
		this.setState({
			isDateBox: true,
		});
	};

	closeWDCalendar = () => {
		this.setState({
			isDateBox: false,
		});
	};

	render() {
		const {
			isShow,
			address,
			isSD,
			isCityTourMode,
			addressArray,
			calendarTemplate,
			wdOneWay,
			selectHour,
			isSelectHour,
			durationTimeArr,
			WDCalendarTemplate,
			WDECalendarTemplate,
			wd,
			wrapperRef,
			// startTime,
			// endTime,
		} = this.props;

		const { err, filter } = this.props.carFinding;

		const { startDate, endDate, startTime, endTime } = filter;

		const { isDateBox } = this.state;

		return (
			<div className={`finding-toggle ${isShow ? "" : "move-left"}`}>
				<div className="m-container" id="home-box">
					<div className="toggle-header">
						<div className="space" />
						<h6>Tìm kiếm</h6>
						<div className="back" onClick={() => this.hide()}>
							×
						</div>
					</div>
					<div className="toggle-footer">
						<a className="btn btn--s btn-primary" onClick={() => this.hide()}>
							Tìm xe ngay
						</a>
					</div>

					{isSD ? (
						<>
							<div className="group-item has-arrow">
								<div className="title">
									<div className="wrap-svg">
										<IcLocationSearch />
									</div>
									<p>Địa điểm</p>
								</div>
								{/* <HereAutoComplete
									suggest={true}
									inputProps={{
										value: address,
										onChange: (address) => this.props.onAddressChange(address),
										onFocus: (e) => this.props.onAddressFocus(e),
									}}
									onSelect={(address) => this.onSelectAddress(address)}
								/> */}
								<SearchSuggest
									sd={true}
									inputProps={{
										value: address,
										onChange: (address) => this.props.onAddressChange(address),
										// onFocus: (e) => this.props.onAddressFocus(e),
									}}
									onSelect={(address) => this.onSelectAddress(address)}
								/>
							</div>
							<div className="line-page" />

							<div className="calendar-wrap" onClick={this.openCalendar}>
								<div className="group-item has-arrow">
									<div className="title">
										<div className="wrap-svg">
											<IcCalendarSearch />
										</div>
										<p>Thời gian</p>
									</div>
									<p className="value">
										{/* {startTime >= 0 ? formatTime(startTime) : "Chọn giờ"},{" "}
										{startDate ? startDate.format("DD/MM/YYYY") : "Chọn ngày"} -{" "}
										{endTime >= 0 ? formatTime(endTime) : "Chọn giờ"}, {endDate ? endDate.format("DD/MM/YYYY") : "Chọn ngày"} */}
										{startTime >= 0 ? formatTime(startTime) : 'Chọn giờ'},{" "}
										{startDate
											? startDate.format("DD/MM/YYYY")
											: "Chọn ngày"}{" "}
										- {endTime >= 0 ? formatTime(endTime) : 'Chọn giờ'},{" "}
										{endDate
											? endDate.format("DD/MM/YYYY")
											: "Chọn ngày"}
									</p>
								</div>

						
							</div>

							{this.state.isCalendar && (
								<DateBox
									startDate={startDate}
									endDate={endDate}
									startTime={startTime}
									endTime={endTime}
									finding={true}
									onStartTimeChange={this.onStartTimeChange}
									onEndTimeChange={this.onEndTimeChange}
									onDatesChange={this.onDateRangeChange}
									show={this.state.isCalendar}
									isMCalendar={true}
									hideModal={this.hideCalendar}
								/>
							)}

						</>
					) : (
						<>
							<div className="wd-option-form">
								{/* <div className="custom-radio">
									<input
										type="radio"
										id="province"
										name="tripMode"
										checked={!isCityTourMode}
										onChange={() => this.onTripModeChange(false)}
									/>
									<label htmlFor="province">Liên tỉnh</label>
								</div>
								<div className="custom-radio">
									<input
										type="radio"
										id="cityTour"
										name="tripMode"
										checked={isCityTourMode}
										onChange={() => this.onTripModeChange(true)}
									/>
									<label htmlFor="cityTour">Nội thành</label>
								</div> */}
								<div className="custom-radio">
									<input
										type="radio"
										id="mcityTourCF"
										name="tripModeMCF"
										checked={isCityTourMode && !wdOneWay}
										onChange={() => this.onTripModeChange({isCityTourMode: true, wdOneWay: false})}
									/>
									<label htmlFor="mcityTourCF">Nội thành</label>
								</div>
								<div className="custom-radio">
									<input
										type="radio"
										id="mprovinceCF"
										name="tripModeMCF"
										checked={!isCityTourMode && !wdOneWay}
										onChange={() => this.onTripModeChange({isCityTourMode: false, wdOneWay: false})}
									/>
									<label htmlFor="mprovinceCF">Liên tỉnh</label>
								</div>
								<div className="custom-radio">
									<input
										type="radio"
										id="mprovinceOneWay"
										name="tripModeMCF"
										checked={!isCityTourMode && wdOneWay}
										onChange={() => this.onTripModeChange({isCityTourMode: false, wdOneWay: true})}
									/>
									<label htmlFor="mprovinceOneWay">Liên tỉnh (1 chiều)</label>
								</div>
							</div>
							{isCityTourMode ? (
								<div className="note">
									Di chuyển nội thành hoặc lân cận, lộ trình tự do.
									<div className="wrap-svg pointer" onClick={() => this.showWdTypeInfoBox(wdType.WDT_CITY_TOUR)}>
										<IcQuestion />
									</div>
								</div>
							) :  wdOneWay ? (
									<div className="note">
										Di chuyển liên tỉnh, trả khách tại điểm đến.
										<div className="wrap-svg pointer" onClick={() => this.showWdTypeInfoBox(wdType.WDT_ONEWAY)}>
											<IcQuestion />
										</div>
									</div>
								) : 
								
								<div className="note">
									Di chuyển liên tỉnh, trả khách về lại điểm đón.
									<div className="wrap-svg pointer" onClick={() => this.showWdTypeInfoBox(wdType.WDT_TWOWAY)}>
										<IcQuestion />
									</div>
								</div>
							}
							<div id="mapWD" ref={this.props.map} className="wrap-map" />
							{isCityTourMode ? (
								<>
									<div className="group-item ">
										<div className="title">
											<div className="wrap-svg">
												<IcLocationSearch />
											</div>
											<p>Địa điểm</p>
										</div>
										{/* <HereAutoComplete
											suggest={true}
											onSelect={(address) => this.props.onSelectAddress(address, 0)}
											inputProps={{
												value: addressArray[0],
												onChange: (address) => this.props.onAddressChange(address, 0),
												onFocus: (e) => this.props.onAddressFocus(e, 0),
												placeholder: "Tôi muốn đón tại...",
											}}
										/> */}
										<SearchSuggest
											inputProps={{
												value: addressArray[0],
												onChange: (address) => this.props.onAddressChange(address, 0),
												// onFocus: (e) => this.props.onAddressFocus(e, 0),
												placeholder: "Tôi muốn đón tại...",
											}}
											onSelect={(address) => this.props.onSelectAddress(address, 0)}
										/>
									</div>
								</>
							) : (
								<>
									{addressArray.map((address, i) => (
										<div className={`group-item ${i > 1 ? "remove" : ""}`} key={i}>
											<div className="title">
												<div className="wrap-svg">{i === 0 ? <IcStartLocWD /> : <IcEndLocWD />}</div>
												<p>{i === 0 ? "Điểm đón" : "Điểm đến"}</p>
											</div>

											{/* <HereAutoComplete
												suggest={true}
												onSelect={(address) => this.props.onSelectAddress(address, i)}
												focusAddress={true}
												inputProps={{
													value: address,
													onChange: (address) => this.props.onAddressChange(address, i),
													onFocus: (e) => this.props.onAddressFocus(e, i),
												}}
											/> */}
											<SearchSuggest
												focusAddress={true}
												inputProps={{
													value: address,
													onChange: (address) => this.props.onAddressChange(address, i),
													// onFocus: (e) => this.props.onAddressFocus(e, i),
												}}
												onSelect={(address) => this.props.onSelectAddress(address, i)}
											/>

											{!(i === 0 || i === 1) && (
												<div className="wrap-svg" onClick={() => this.props.onRemoveStopPoint(i)}>
													<IcCloseOrange />
												</div>
											)}
										</div>
									))}

									{(addressArray[1] !== "" || addressArray.length > 2) && addressArray.length < 4 && (
										<div className="add-route" onClick={this.onAddStopPoint}>
											<div className="wrap-svg">
												<IcPlusCGreen />
											</div>
											<p>Thêm điểm đến</p>
										</div>
									)}

									<div className="custom-checkbox-selected">
										<input type="checkbox" id="cbOneWay" checked={wdOneWay} onChange={this.onOneWayChange} />
										<label htmlFor="cbOneWay">Tôi muốn đi một chiều</label>
									</div>

									{!wdOneWay && (
										<div className="group-item">
											<div className="title">
												<div className="wrap-svg">
													<IcCompass />
												</div>
												<p className="font-16 text-black fontWeight-4">Trả khách tại điểm đón</p>
											</div>
										</div>
									)}
								</>
							)}

							<div className="line-page" />

							<div className="group-item has-arrow" onClick={this.openWDCalendar}>
								<div className="title">
									<div className="wrap-svg">
										<IcCalendarSearch />
									</div>
									<p>Thời gian</p>
								</div>
								<p className="value">
									{startTime >= 0 ? formatTime(startTime) : 'Chọn giờ'},{" "}
										{startDate
											? startDate.format("DD/MM/YYYY")
											: "Chọn ngày"}{" "}
										- {endTime >= 0 ? formatTime(endTime) : 'Chọn giờ'},{" "}
										{endDate
											? endDate.format("DD/MM/YYYY")
											: "Chọn ngày"}
						
								</p>
							</div>
							
							{!addressArray.includes("") && (
								<div className="note-route">
									{wd && wd.distanceInKM && wd.distanceInKM > 0 && filter.wdDistance > 0 && !isCityTourMode ? (
										<div className="note-route__item">
											<p>Tổng lộ trình</p>
											<p>{wd.distanceInKM.toFixed(1)} km</p>
										</div>
									) : null}
									{wd && wd.limitKM && wd.limitKM > 0 && (
										<div className="note-route__item">
											<p>Số km được đi</p>
											<p>{wd.limitKM} km</p>
										</div>
									)}
								</div>
							)}

							{isDateBox && (
								<DateBoxWD
									startDate={startDate}
									endDate={endDate}
									startTime={startTime}
									endTime={endTime}
									finding={true}
									onStartTimeChange={this.onStartTimeChange}
									onEndTimeChange={this.onEndTimeChange}
									onStartDateChange={this.onStartDateChange}
									onDatesChange={this.onDateRangeChange}
									show={isDateBox}
									isMCalendar={true}
									hideModal={this.closeWDCalendar}
									wrapperSelect={wrapperRef}
									toggleDurationTimeBox={this.toggleDurationTimeBox}
									onSelectHourChange={this.onSelectHourChange}
									selectHour={selectHour}
									durationTimeArr={durationTimeArr}
									isSelectHour={isSelectHour}
								/>
							)}
						</>
					)}
				</div>
			</div>
		);
	}
}

function mapState(state) {
	return {
		carFinding: state.carFinding,
	};
}

SearchBox = connect(mapState)(SearchBox);

export default SearchBox;


{/* <DateRangePicker
								initialSettings={{
									startDate: startDate,
									endDate: startDate,
									minDate: moment(),
									maxDate: moment().add(3, "months"),
									timePicker: true,
									timePicker24Hour: true,
									timePickerIncrement: 30,
									singleDatePicker: true,

									isIOs: isIOS,
									template: WDCalendarTemplate,
									buttonClasses: ["btn btn--m btn-primary"],
									locale: {
										applyLabel: "Áp dụng",
									},
									opens: "center",
									parentEl: "#home-box",
									linkedCalendars: true,
									singelSelect: true,
								}}
								onHide={(event, picker) => this.onStartDateChange(event, picker)}>
								<div className="group-item has-arrow">
									<div className="title">
										<div className="wrap-svg">
											<IcCalendarSearch />
										</div>
										<p>Thời gian</p>
									</div>
									<p className="value">{startDate ? startDate.format("DD/MM/YYYY - HH:mm") : "Chọn ngày"}</p>
								</div>
							</DateRangePicker> */}

							{/* <div className="line-page" /> */}

							{/* <div className="group-item has-arrow">
								<div className="title">
									<IcCalendarSearch />
									<p>Kết thúc</p>
								</div>
								<p className="value">{endDate ? endDate.format("DD/MM/YYYY - HH:mm") : "Chọn ngày"}</p>
							</div> */}

							{/* <div className="group-item has-arrow" ref={wrapperRef}>
								<div className="title">
									<div className="wrap-svg">
										<IcTime />
									</div>
									<p>Thời gian thuê</p>
								</div>
								<p className="value" onClick={() => this.toggleDurationTimeBox(isSelectHour)}>
									{selectHour > 0 ? (
										<>
											{convertToHourText(selectHour)}
											<span className="note-time">(kết thúc {endDate.format("HH:mm - DD/MM/YYYY")})</span>
										</>
									) : (
										"Tùy chỉnh"
									)}
								</p>

								{isSelectHour && (
									<div className="options">
										{durationTimeArr &&
											durationTimeArr.map((time) => (
												<div className="custom-radio" key={time}>
													<input
														type="radio"
														id={`cf_time_${time}`}
														name="cf_selectHour"
														value={time}
														checked={selectHour === time}
														onChange={this.onSelectHourChange}
													/>
													{time > 0 ? (
														<label htmlFor={`cf_time_${time}`}>
															{convertToHourText(time)}
															<span className="note-time">
																{getEndDatewd(time, startDate).format("HH:mm DD/MM/YYYY")}
															</span>
														</label>
													) : (
														<label htmlFor={`cf_time_${time}`}>Tùy chỉnh</label>
													)}
												</div>
											))}
									</div>
								)}
							</div> */}

							{/* {selectHour == 0 && (
								<>
									<div className="line-page" />
									<DateRangePicker
										initialSettings={{
											startDate: endDate,
											endDate: endDate,
											minDate: moment(),
											maxDate: moment().add(3, "months"),
											timePicker: true,
											timePicker24Hour: true,
											timePickerIncrement: 30,
											singleDatePicker: true,
											autoApply: true,
											isIOs: isIOS,
											template: WDECalendarTemplate,
											buttonClasses: ["btn btn--m btn-primary"],
											locale: {
												applyLabel: "Áp dụng",
											},
											opens: "center",
											parentEl: "#home-box",
											linkedCalendars: true,
											singelSelect: true,
										}}
										onHide={(event, picker) => this.onEndDateChange(event, picker)}>
										<div className="group-item has-arrow">
											<div className="title">
												<IcCalendarSearch />
												<p>Kết thúc</p>
											</div>
											<p className="value">{endDate ? endDate.format("DD/MM/YYYY - HH:mm") : "Chọn ngày"}</p>
										</div>
									</DateRangePicker>
								</>
							)} */}
